import React from 'react';
import DefaultResultItem from './DefaultResultItem';
import { ResultItemProps } from 'components/ui/Results/ResultItem';
// #region Commerce
import ProductResultItem from './commerce/ProductResultItem';
// #endregion

function RocHawkResultItem({ item, testId }: ResultItemProps) {
	const itemType = item.getDocumentValue('roctype');

	switch (itemType) {
		// #region Commerce
		case 'Product':
			return <ProductResultItem item={item} testId={testId} />;
		// #endregion
		default:
			return <DefaultResultItem item={item} testId={testId} />;
	}
}

export default RocHawkResultItem;
